<div class="row wrapper border-bottom white-bg page-heading info-projeto">
  <div class="col-lg-10 title-projeto">
    <h2>{{projeto?.title}}</h2>
  </div>
  <div class="row" *ngIf="this.projeto">
    <div class="col-lg-12">
      <div class="title">
        Órgão responsável <span class="content">{{projeto?.agency?.name}}</span>
      </div>
      <div class="title">
        Gerente <span class="content">{{projeto?.manager?.name}}</span>
      </div>
    </div>
  </div>

  <div class="col-lg-10">
    <h2>{{type ? 'Programa' : 'Projeto Agregador'}}</h2>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">

        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>{{ actionLabel }} Indicador</h3>
          </div>

          <div class="alert alert-info" *ngIf="indicador?.readonly">
            <h5>Info: </h5>
            <ul>
              <li>Você não tem autorização para editar</li>
            </ul>
          </div>

          <div class="tabMenu" *ngIf="indicador?.id; else addIndicador">
            <tabset>
              <tab heading="Configurar" id="tab1">
                <app-detalhe-pg-indicadores-config-edit></app-detalhe-pg-indicadores-config-edit>
              </tab>
              <tab heading="Metas">
                <app-detalhe-pg-indicadores-meta-edit></app-detalhe-pg-indicadores-meta-edit>
              </tab>
              <tab heading="Indicadores Somados" *ngIf="indicador?.can_see_summed">
                <app-detalhe-pg-indicadores-somatorio-edit></app-detalhe-pg-indicadores-somatorio-edit>
              </tab>
            </tabset>
          </div>

          <ng-template #addIndicador>
            <app-detalhe-pg-indicadores-config-edit></app-detalhe-pg-indicadores-config-edit>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>